import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'home',
  component: () => import('../views/HomeView.vue')
},
{
  path: '/jianxin',
  redirect: '/jianxin/raw-1'
},
{
  path: '/jianxin/raw-1',
  name: 'jianxinRaw1',
  component: () => import('../views/JianXinView.vue'),
  meta: { title: '蚕病智防' }
},
{
  path: '/jianxin/raw-2',
  name: 'jianxinRaw2',
  component: () => import('../views/ZhiNengWeiYangView.vue'),
  meta: { title: '智能喂养' }
},
{
  path: '/jianxin/raw-3',
  name: 'jianxinRaw3',
  component: () => import('../views/CanJianZhiFenView.vue'),
  meta: { title: '蚕茧智分' }
},
{
  path: '/header',
  name: 'header',
  component: () => import('../views/HeaderView.vue')
},
{
  path: '/footer',
  name: 'footer',
  component: () => import('../views/FooterView.vue')
},
{
  path: '/excellent-embroiderer',
  name: 'excellentEmbroiderer',
  component: () => import('../views/ExcellentEmbroidererView.vue')
},
{
  path: '/embroiderer/:id',
  name: 'embroidererDetail',
  component: () => import('../views/EmbroidererDetailView.vue')
},
{
  path: '/museum',
  name: 'Museum',
  component: () => import('../views/MuseumView.vue')
},
{
  path: '/trace/raw',
  name: 'RawTrace',
  component: () => import('../views/YuanLiaoTraceView.vue'),
  meta: { title: '原料溯源' }
},
{
  path: '/trace',
  name: 'Trace',
  component: () => import('../views/TraceView.vue'),
  meta: { title: '成品溯源' }
},
{
  path: '/joint-test',
  name: 'JointTest',
  component: () => import('../views/LianTiaoTestView.vue'),
  meta: { title: '联调测试' }
},
{
  path: '/xiunianglive',
  name: 'xiunianglive',
  component: () => import('../views/XiuNiangLiveView.vue')
},
{
  path: '/cansilive',
  name: 'cansilive',
  component: () => import('../views/CanSiLiveView.vue')
},
{
  path: '/personalization',
  name: 'personalization',
  component: () => import('../views/PersonalizationView.vue')
},

{
  path: '/silkworm',
  name: 'silkworm',
  component: () => import('../views/Silkworm.vue')
},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router